import "./updateTickeTimeSolved.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import newRequest from "../../context/newRequest";
import {sleep} from "../../helper/helper";

const UpdateTicketTimeSolved = ({ title }) => {
  const [ticketSolved, setTicketSolved] = useState({});
  const [sending, setSending] = useState("");
  const { ticketId } = useParams();
  const user = localStorage.getItem("user");
  const { data, loading, error } = useFetch(`/solve/${ticketId}`);
  const navigate = useNavigate();
  const [upTime, setUpTime] = useState(""); // For storing user-selected Up Time
  const [downTime, setDownTime] = useState(""); //

  useEffect(() => {
    setTicketSolved(data);
  }, [data]);



  const dateTicket = () => {
    const dateCreated = new Date(ticketSolved.created_at);
    const dateUpdate = new Date(ticketSolved.updated_at);
    const downTime = new Date(ticketSolved.down_time);
    const UpTime = new Date(ticketSolved.up_time);
    const dateSubmit = new Date(ticketSolved.date_submit);

    const date = {
      create_at : dateCreated.toLocaleString(),
      updated_at: dateUpdate.toLocaleString(),
      down_time : downTime.toLocaleString(),
      up_time : UpTime.toLocaleString(),
      date_submit: dateSubmit.toLocaleString(),

    }
    return date;
  }
  const date = dateTicket()





  const handleClick = async (e) => {
    e.preventDefault();
    setSending("On Submit")
    try {
      setSending("Mengirim Data")
      const upTimeMillis = new Date(upTime).getTime();
      const downTimeMillis = new Date(downTime).getTime();

      const newTicketUpdate = {
        up_time: upTimeMillis,
        down_time: downTimeMillis,
      };

      const res= await newRequest.put(`/solve/time/${ticketId}`, newTicketUpdate, {
        // headers
        headers: {
          'Authorization': `$Bearer ${user.token}`
        },
      });
      if (res.status == 200) {
        await sleep(2000)
        setSending("Berhasil Mengirim Data")
        navigate(`/solve/${ticketId}`);
      }
      console.log(res.status)
    } catch (err) {
      setSending(err.response.data.errors)
      console.log(err);
    }
  };
  return (
      <div className="new">
        <Sidebar />
        <div className="newContainer">
          <Navbar />
          <div className="top">
            <h1>{title}</h1>
          </div>
          <div className="bottom">
            <div className="right">
              <div className="detailItem">
                <span className="itemKey">Ticket ID:</span>
                <span className="itemValue">{ticketId}</span>
              </div>
              <div className="detailItem">
                <span className="itemKey">Segment Customer:</span>
                <span className="itemValue">
                        {ticketSolved.segment_customer}
                  </span>
              </div>

              <div className="detailItem">
                <span className="itemKey">Down Time:</span>
                <span className="itemValue">{date.down_time}</span>
              </div>
              <br/>
              <div className="detailItem">
                <span className="itemKey">Up Time:</span>
                <span className="itemValue">{date.up_time}</span>
              </div>

              <form>
                <div className="formInput">

                  <label><b>DOWN TIME :</b></label>
                  <input
                      type="datetime-local"
                      onChange={(e) => setDownTime(e.target.value)}
                  />

                  <br/>
                  <br/>
                  <br/>
                  <br/><br/>
                  <label><b>UP TIME :</b></label>
                  <input
                      type="datetime-local"
                      onChange={(e) => setUpTime(e.target.value)}
                  />


                  <button onClick={handleClick}>Send</button>

                </div>
              </form>
            </div>
          </div>
          {sending && <p className="error">{sending}</p>}
        </div>
      </div>
  );
};

export default UpdateTicketTimeSolved;